import { Story, Chapter } from '@/utils/types';
import { clientApi } from './axiosConfig';

/**
 * Fetch all stories from the API
 * Calls the Next.js API proxy route which handles backend communication
 * Returns the API response as-is without any modification
 */
export async function getAllStories(channel?: string): Promise<Story[]> {
  try {
    const params: Record<string, string> = {};
    if (channel) {
      params.channel = channel;
    }
    const response = await clientApi.get('/stories', { params });
    return response.data.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Fetch a single story by ID from the API
 * Calls the Next.js API proxy route which handles backend communication
 * Returns the API response as-is without any modification
 */
export async function getStoryById(id: string): Promise<Story> {
  try {
    const response = await clientApi.get('/stories', {
      params: { id },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Fetch a single chapter by ID from the API
 * Calls the Next.js API proxy route which handles backend communication
 * Returns the API response as-is without any modification
 */
export async function getChapterById(chapterId: string): Promise<Chapter> {
  try {
    const response = await clientApi.get(`/chapters/${chapterId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

/**
 * Update like/dislike for a chapter
 * @param chapterId - Chapter ID
 * @param action - 1 for like, 0 for dislike
 */
export async function updateChapterLike(
  chapterId: string,
  action: 1 | 0
): Promise<Chapter> {
  try {
    const url = `/chapters/${chapterId}/like?action=${String(action)}`;
    const response = await clientApi.patch(url);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}

/**
 * Update views count for a chapter
 * @param chapterId - Chapter ID
 */
export async function updateChapterViews(chapterId: string): Promise<Chapter> {
  try {
    const url = `/chapters/${chapterId}/views`;
    const response = await clientApi.patch(url);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}

/**
 * Fetch comments for a chapter
 * @param chapterId - Chapter ID
 */
export async function getChapterComments(chapterId: string): Promise<any[]> {
  try {
    const url = `/chapters/${chapterId}/comments`;
    const response = await clientApi.get(url);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}

/**
 * Post a comment to a chapter
 * @param chapterId - Chapter ID
 * @param name - Commenter name
 * @param comment - Comment text
 */
export async function postChapterComment(
  chapterId: string,
  name: string,
  comment: string
): Promise<any> {
  try {
    const url = `/chapters/${chapterId}/comments`;
    const response = await clientApi.post(url, { name, comment });
    return response.data;
  } catch (error: any) {
    throw error;
  }
}









